import React from 'react';

interface FacebookPageSelectorProps {
  integrationName: string;
  pagesLoading: boolean;
  facebookPages: any[];
  selectedPageForUpdate: string;
  onSelectPage: (pageId: string) => void;
  onConfirmSelect: () => void;
}

const FacebookPageSelector: React.FC<FacebookPageSelectorProps> = ({
  integrationName,
  pagesLoading,
  facebookPages,
  selectedPageForUpdate,
  onSelectPage,
  onConfirmSelect,
}) => {
  return (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-white text-2xl font-semibold mb-5 text-center">Select {integrationName} Page</h2>

      {pagesLoading ? (
        <div className="flex flex-col items-center justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-primary mb-4"></div>
          <p className="text-gray-400 text-sm">Fetching pages...</p>
        </div>
      ) : facebookPages.length > 0 ? (
        <div className="space-y-3 mb-6">
          {facebookPages.map((page: any) => (
            <label
              key={page.id}
              className={`flex items-center gap-4 p-2 rounded-xl cursor-pointer transition-all ${
                selectedPageForUpdate === page.id
                  ? 'bg-blue-600/20 border-2 border-blue-500'
                  : 'bg-[#2a2a2a] border-2 border-transparent hover:border-gray-600'
              }`}
            >
              <div className="relative flex items-center justify-center flex-shrink-0">
                <input
                  type="radio"
                  name="page"
                  value={page.id}
                  checked={selectedPageForUpdate === page.id}
                  onChange={(e) => onSelectPage(e.target.value)}
                  className="sr-only"
                />
                <div
                  className={`w-6 h-6 rounded-full border-1 flex items-center justify-center transition-all ${
                    selectedPageForUpdate === page.id
                      ? 'border-blue-500 bg-blue-500'
                      : 'border-gray-500 bg-transparent'
                  }`}
                >
                  {selectedPageForUpdate === page.id && (
                    <div className="w-2 h-2 rounded-full bg-white"></div>
                  )}
                </div>
              </div>

              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-600 to-gray-700 flex items-center justify-center flex-shrink-0 overflow-hidden">
                {page.picture?.data?.url ? (
                  <img src={page.picture.data.url} alt={page.name} className="w-full h-full object-cover" />
                ) : (
                  <span className="text-white text-lg font-medium">{page.name.charAt(0).toUpperCase()}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-white font-medium text-lg truncate">{page.name}</h3>
              </div>
            </label>
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg">No pages available</p>
        </div>
      )}

      {!pagesLoading && facebookPages.length > 0 && (
        <button
          onClick={onConfirmSelect}
          disabled={!selectedPageForUpdate}
          className="w-full py-4 rounded-xl font-semibold text-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed bg-brand-primary hover:bg-[#ee4423] text-white shadow-lg"
        >
          Select
        </button>
      )}
    </div>
  );
};

export default FacebookPageSelector;
